var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16,0 C7.163444,1.623249e-15 -4.37147301e-14,7.163444 -4.26325641e-14,16 C-4.15503981e-14,24.836556 7.163444,32 16,32 C24.836556,32 32,24.836556 32,16 C32,7.163444 24.836556,-1.623249e-15 16,0 Z M12,23 L8,23 L8,11 L12,11 L12,23 Z M10,10 C8.894,10 8,9.106 8,8 C8,6.894 8.894,6 10,6 C11.106,6 12,6.894 12,8 C12,9.106 11.106,10 10,10 Z M25,23 L21.3333333,23 L21.3333333,16.1428571 C21.3333333,15.1948571 20.5138333,14.4285714 19.5,14.4285714 C18.4861667,14.4285714 17.6666667,15.1948571 17.6666667,16.1428571 L17.6666667,23 L14,23 L14,11 L17.6666667,11 L17.6666667,13.1265714 C18.4229167,12.1571429 19.57975,11 20.875,11 C23.1556667,11 25,12.9182857 25,15.2857143 L25,23 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.f2d2b1c311007d1d4777741f077940a9.svg";
export { ForwardRef as ReactComponent };